module.exports = __webpack_public_path__ + "img/Anhänger_NEA_50kVA_LiMa.7c6ad095.svg";